/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * score_by_attempt only: of the n sessions, how many submitted this attempt
 */
export type ExtrasNRevising = number | null;
